Monet.Format = Monet.Format || {};
Monet.Format.TIME = (function () {
  function TIME(value) {
    Monet.Format.DATE.apply(this, arguments);
    this.value = value || "";

    this.toGrid = function () {
      const valueParsed = this.value && Monet.Format.Time.parse(this.value);
      this.value = Monet.Format.Time.formatToLocale(valueParsed);
      return this;
    };
  }

  return TIME;
}());

Monet.Format.Time = {
  parse(inputTime, options) {
    if (typeof inputTime === 'number') {
      return Monet.Format.Date.parse(inputTime, options);
    }
    const timeParts = inputTime.split(':').length;
    let pattern = timeParts === 3 ? 'HH:mm:ss' : 'HH:mm';
    const meridiemParts = inputTime.split(' ').length;
    if(meridiemParts === 2) {
      pattern = timeParts === 3 ? 'hh:mm:ss a' : 'hh:mm a';
    }

    return Monet.Format.Date.parse(inputTime, { pattern, ...options });
  },

  formatToLocale(inputTime, options) {
    return Monet.Format.Date.format(inputTime, { pattern: Monet.I18n.locale.timeFormat, ...options });
  }
};
